module.exports = __webpack_public_path__ + "static/media/armed.c85267cb.png";